import React from 'react';
import { Headline1 } from '@cdm/quickenloans-library/lib';
import parseHTML from '../../../utilities/parseHTML';

const titleTransformer = (query) =>
{
    const { title, databaseId } = query?.post ?? {};
    
    return (
        <Headline1 className="h1_bold" testId={`headline-h1-${databaseId}`}>
            <span itemProp="headline">{parseHTML(title, ['learningCenter']).parsed}</span>
        </Headline1>
    )
}

export default titleTransformer;